import { useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "../ui/sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { name: "", city: "", message: "" };
const inputCls = "mt-2 w-full border-b-2 border-mm-ink bg-transparent py-2 outline-none focus:border-mm-red transition-colors";

export const SignatureForm = ({ onSigned }) => {
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.name.trim().length < 2 || form.city.trim().length < 2) {
      toast.error("Merci d'indiquer votre prénom, votre nom et votre ville.");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/signatures`, { ...form, message: form.message || null });
      toast.success("Merci ! Votre signature a bien été enregistrée.");
      setForm(EMPTY);
      onSigned();
    } catch {
      toast.error("La signature n'a pas pu être enregistrée. Réessayez dans un instant.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form className="min-w-0 space-y-6" onSubmit={submit} data-testid="signature-form">
      <label className="block"><span className="mm-lab">Prénom et nom</span>
        <input type="text" maxLength={80} value={form.name} onChange={set("name")} className={inputCls} data-testid="signature-name-input" required />
      </label>
      <label className="block"><span className="mm-lab">Ville</span>
        <input type="text" maxLength={80} value={form.city} onChange={set("city")} className={inputCls} data-testid="signature-city-input" required />
      </label>
      <label className="block"><span className="mm-lab">Votre réaction (facultatif)</span>
        <textarea rows={4} maxLength={600} value={form.message} onChange={set("message")} className="mt-2 w-full border-2 border-mm-ink bg-transparent p-3 outline-none focus:border-mm-red transition-colors" data-testid="signature-message-input" />
      </label>
      <p className="text-xs opacity-70">Votre prénom, votre nom, votre ville et votre réaction seront affichés publiquement sur cette page.</p>
      <button type="submit" disabled={sending} data-testid="signature-submit-btn" className="w-full inline-flex items-center justify-center gap-2 bg-mm-red text-white py-4 font-bold hover:bg-mm-ink transition-colors disabled:opacity-60">
        {sending && <Loader2 className="w-4 h-4 animate-spin" />} Signer la lettre
      </button>
    </form>
  );
};
